import React from 'react';
import { Skeleton } from '../ui/skeleton';
import { useTileLoadGate } from '../../hooks/useTileLoadGate';

const TileSkeleton = () => (
  <div className="h-full w-full p-4">
    <Skeleton className="h-full w-full" />
  </div>
);

/**
 * Wraps a dashboard tile so its real content — and therefore its
 * fetch-on-mount effect — doesn't mount until the tile-load scheduler grants
 * it (see lib/tileLoadScheduler). Once granted it stays mounted; a tile is
 * never un-mounted again on scroll-away or tab-switch-away, since that would
 * discard already-fetched data and force a redundant re-fetch.
 */
const LazyTileMount = ({ id, tab, isActiveTab, gridY, children }) => {
  const { ref, ready } = useTileLoadGate({ id, tab, isActiveTab, gridY });

  return (
    <div ref={ref} className="h-full w-full">
      {ready ? children : <TileSkeleton />}
    </div>
  );
};

export default LazyTileMount;
